import { useEffect, useState } from "react";
import Reports from "../components/reports";
import { RIU_REPORT_DATA } from "../constants/data.cnst";
import { TABLE_COLUMNS_CONFIG, type ColumnMeta } from "../constants/table.cnst";
import type { RIU_REPORT } from "../interfaces/dashboard";

export default function RIU() {
    const rIUReportTableColumns: ColumnMeta[] = TABLE_COLUMNS_CONFIG.RIU_REPORT;

    const [rIUReportTableData, setRIUReportTableData] = useState<RIU_REPORT[]>([]);

    useEffect(() => {
        setRIUReportTableData(RIU_REPORT_DATA)
    }, []);

    return (
        <Reports
        reportType='RIU'
        tableColumns={rIUReportTableColumns}
        tableData={rIUReportTableData} />
    );
}